import React, { useState } from "react";
import { TextField, Button, Container, Typography, Box } from "@mui/material";
import styled from "styled-components";
import API from "../../../utils/api";

const FormContainer = styled(Container)`
  background-color: #1b1a2ea9;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0px 10px 10px 0px rgba(9, 5, 29, 0.171);
  backdrop-filter: blur(15px);
  color: white;
`;

const StyledTextField = styled(TextField)`
  & .MuiInputBase-root {
    color: white;
  }
  & .MuiInputLabel-root {
    color: white;
  }
  & .MuiOutlinedInput-root {
    & fieldset {
      border-color: white;
    }
    &:hover fieldset {
      border-color: #c770f0;
    }
    &.Mui-focused fieldset {
      border-color: #c770f0;
    }
  }
  margin-bottom: 1rem;
`;

const StyledButton = styled(Button)`
  background-color: #623686;
  color: white;
  &:hover {
    background-color: #6d20c5d7;
  }
`;

const ReadingForm = () => {
  const [projectData, setProjectData] = useState({
    title: "",
    imgName: "",
    description: "",
    link: "",
    refLink: "",
    isBlog: false,
    date: new Date(),
    rank: 0,
  });

  const handleChange = (e) => {
    setProjectData({ ...projectData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await API.post("/api/paper/add", projectData);
      alert("Project submitted successfully");
      setProjectData({
        title: "",
        link: "",
        refLink: "",
        date: new Date(),
      });
    } catch (error) {
      console.error(error);
      alert("Error submitting project", error);
    }
  };

  return (
    <Container fluid className="resume-section">
      <FormContainer maxWidth="sm">
        <Typography variant="h4" gutterBottom className="purple">
          Submit Your Reading
        </Typography>
        <form onSubmit={handleSubmit}>
          <StyledTextField
            size="small"
            fullWidth
            variant="outlined"
            label="Title"
            name="title"
            value={projectData.title}
            onChange={handleChange}
            required
          />
          <StyledTextField
            size="small"
            fullWidth
            variant="outlined"
            label="Link"
            name="link"
            value={projectData.link}
            onChange={handleChange}
            required
          />
          <StyledTextField
            size="small"
            fullWidth
            variant="outlined"
            label="Reference Link"
            name="refLink"
            value={projectData.refLink}
            onChange={handleChange}
          />
          <Box mt={2}>
            <StyledButton variant="contained" type="submit">
              Submit
            </StyledButton>
          </Box>
        </form>
      </FormContainer>
    </Container>
  );
};

export default ReadingForm;
